// extracted by mini-css-extract-plugin
export default {"spinner":"VideoLibraryContainer_spinner__3Ngi9"};